import React from 'react';
import { Link } from 'react-router-dom';
import { HStack, Text } from '@chakra-ui/react';
import { spacing, colors } from '../../../App/ChakraTheme';
import styled from '../../../consts/styled';

import { MediaTypeIcon } from '../../../scripts/getMediaTypeIcon';
import { FullGuide } from '../hooks/api/types';
import { User } from '../../../context/AuthProvider';

interface PreparationMaterialProps {
  route: string;
  obj: FullGuide;
  user: User;

  className: string;
}

const PreparationMaterial: React.FC<PreparationMaterialProps> = (props) => {
  const { route, obj, user } = props;

  const disabled = user?.is_demo && !obj?.isDemo;

  return (
    <Link
      className={props.className}
      style={
        disabled
          ? {
              cursor: 'not-allowed',
              opacity: 0.5,
              textDecoration: 'none',
              pointerEvents: 'none',
            }
          : {}
      }
      to={route}
      title={obj.name}
    >
      <HStack w="full" className={'v-center'}>
        <MediaTypeIcon
          boxSize="24px"
          className="icon"
          mediaType={obj.media_type}
        />
        <Text as="span" textStyle="bodyMedium" className="text">
          {obj.name}
        </Text>
      </HStack>
    </Link>
  );
};

export const PreparationMaterialComponent = styled(PreparationMaterial as any)<
  Omit<PreparationMaterialProps, 'className'>
>`
  cursor: pointer;
  border-radius: 4px;
  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out,
    background-color 0.3s ease-out;
  transition-delay: 0.1s;
  transform: translateY(0);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  padding: ${spacing.SMALL};
  width: 100%;
  max-width: 100%;

  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.15);
    background-color: ${colors.applyOpacity(colors.mischka, 0.2)};
    transform: translateY(-2px);
  }

  .icon {
    margin-right: ${spacing.SMALL};
    flex-shrink: 0;
  }
  .text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
